/** Shared target for opening a booking; route migrations belong here. */
export const bookingHref = (id: string) => `/bookings/${encodeURIComponent(id)}`;
